import React from "react";

export default function QuotableTableWrapper({ children }) {
  return (
    <table className="quotable_items">
      <thead>
        <tr>
          <th style={{ width: 30 }}>&nbsp;</th>
          <th>Analysis</th>
          <th>LOD</th>
          <th>Technique</th>
          <th>Accreditation</th>
          <th>Units</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}
